module.exports = __webpack_public_path__ + "img/singapore.3cba6da2.png";